/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
 
  LOAD_ALTER_QUOTE_PENDING,
  LOAD_ALTER_QUOTE_PENDING_SUCCESS,
  LOAD_ALTER_QUOTE_PENDING_ERROR,
  ALTER_QUOTE_REQUEST,
  ALTER_QUOTE_REQUEST_SUCCESS,
  ALTER_QUOTE_REQUEST_ERROR,
  UPDATE_ALTER_QUOTE,
  UPDATE_ALTER_QUOTE_SUCCESS,
  UPDATE_ALTER_QUOTE_ERROR,
  LOAD_ALTER_QUOTE_HISTORY,
  LOAD_ALTER_QUOTE_HISTORY_SUCCESS,
  LOAD_ALTER_QUOTE_HISTORY_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(alterQuoteMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    alterQuoteMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


///Alter quote request

/**
 *
 * @param {string} id
 * @param {function} setSubmitting
 * @param {function} redirect
 * @returns
 */
 export function alterQuoteRequest(alterQuote) {
  
  return {
    type: ALTER_QUOTE_REQUEST,
    alterQuote
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function alterQuoteRequestSuccess(
  alterQuote,success
) {

  return {
    type: ALTER_QUOTE_REQUEST_SUCCESS,
  alterQuote,
    success,
  }
}
/**
 * @param {string} error
 */
 export function alterQuoteRequestError(error) {
  return {
    type: ALTER_QUOTE_REQUEST_ERROR,
    error,
  }
}

//Re-approve update API

/**
 *
 * @returns
 */
export function updateAlterQuote(alterQuoteData) {
  return {
    type: UPDATE_ALTER_QUOTE,
    alterQuoteData,
  }
}

/**
 *
 * @param {integer} id
 * @param {string} success
 * @returns
 */
export function updateAlterQuoteSuccess(success, alterQuoteData) {
  return {
    type: UPDATE_ALTER_QUOTE_SUCCESS,
    alterQuoteData,
    success,
  }
}

/**
 * @param {string} error
 */
export function updateAlterQuoteError(error) {
  return {
    type: UPDATE_ALTER_QUOTE_ERROR,
    error,
  }
}

// Load Sales Pending Approval
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadAlterQuotePending(searchValue) {
  return {
    type: LOAD_ALTER_QUOTE_PENDING,
    searchValue
  }
}

export function loadAlterQuotePendingSuccess(alter_quote_details) {
  return {
    type: LOAD_ALTER_QUOTE_PENDING_SUCCESS,
    alter_quote_details,
  }
}

/**
 * @param {string} error
 */

export function loadAlterQuotePendingError(error) {
  return {
    type: LOAD_ALTER_QUOTE_PENDING_ERROR,
    error,
  }
}

//Qc list
/**
 *
 * @param {integer} id
 * @returns
 */
 export function loadAlterQuoteHistory(id) {
  return {
    type: LOAD_ALTER_QUOTE_HISTORY,
    id,
  }
}

export function loadAlterQuoteHistorySuccess(alter_quote_history) {
  return {
    type: LOAD_ALTER_QUOTE_HISTORY_SUCCESS,
    alter_quote_history,
  }
}

/**
 * @param {string} error
 */

export function loadAlterQuoteHistoryError(error) {
  return {
    type: LOAD_ALTER_QUOTE_HISTORY_ERROR,
    error,
  }
}


const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

 
  loadAlterQuotePending,
  loadAlterQuotePendingSuccess,
  loadAlterQuotePendingError,

  loadAlterQuoteHistory,
  loadAlterQuoteHistorySuccess,
  loadAlterQuoteHistoryError,

  alterQuoteRequest,
  alterQuoteRequestSuccess,
  alterQuoteRequestError,
  
  updateAlterQuote,
  updateAlterQuoteSuccess,
  updateAlterQuoteError,
}

export default actions
